import {createContext, type MutableRefObject, useContext} from 'react';

export type InputOTPContextValue = {
  slots: string[];
  activeIndex: number;
  maxLength: number;
  disabled: boolean;
  error: boolean;
  setActiveIndex: (index: number) => void;
  handleDigitInput: (index: number, digit: string) => void;
  handleDelete: (index: number) => void;
  handlePaste: (text: string) => void;
  inputRefs: MutableRefObject<(HTMLInputElement | null)[]>;
};

const InputOTPContext = createContext<InputOTPContextValue | null>(null);

function useInputOTPContext() {
  const ctx = useContext(InputOTPContext);

  if (!ctx) {
    throw new Error('InputOTP compound components must be used within <InputOTP>');
  }

  return ctx;
}

const DIGIT_REGEX = /^\d$/;

function extractDigits(str: string): string {
  return str.replace(/\D/g, '');
}

export {InputOTPContext, useInputOTPContext, DIGIT_REGEX, extractDigits};
